<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slproducttender}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.userName" placeholder="用户姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slproducttender:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:slproducttender:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userName" label="用户姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="申请人手机" header-align="center" align="center"></el-table-column>
        <el-table-column prop="inviteUserId" label="经纪人ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bizFlow" label="业务流水唯一编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ getStatus( scope.row.status ) }}
          </template>
        </el-table-column>
        <el-table-column prop="nextStatus" label="进件状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ getStatus( scope.row.nextStatus ) }}
          </template>
        </el-table-column>
        <el-table-column prop="productCode" label="产品CODE" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="investTime" label="投资时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="failMsg" label="失败原因" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realAmount" label="核额金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realTime" label="核额时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="loanAmount" label="放款金额" header-align="center" align="center"></el-table-column>
        <el-table-column prop="loanTime" label="放款时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:slproducttender:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <!-- <el-button v-if="$hasPermission('sys:slproducttender:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './slproducttender-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/slproducttender/page',
        getDataListIsPage: true,
        exportURL: '/sys/slproducttender/export',
        deleteURL: '/sys/slproducttender',
        deleteIsBatch: true
      },
      entryStatusList:[],
      dataForm: {
        id: ''
      }
    }
  },
  created(){
    this.getentryStatusOptions()
  },
  methods:{
        getStatus(v){
          return this.entryStatusList.filter(item => item.value == v)[0].label
        },
        //初始进件状态下拉框中的选项
        async getentryStatusOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=entryStatus`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.entryStatusList=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.entryStatusList.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  },
  components: {
    AddOrUpdate
  }
}
</script>
